import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import FormModal from '../../../FormModal.jsx';
import OrgStakeholderForm from './OrgStakeholderForm.jsx';
import { createOrgStakeholder } from '../../../../modules/orgStakeholders.js';

const mapDispatchToProps = { createOrgStakeholder };

function OrgStakeholderFormModal(props) {
  const {
    onHide,
    show,
    onSubmitSuccess,
    stakeholderTypeOptions,
    createOrgStakeholder,
    preselectedType,
  } = props;

  const initialValues = { objectType: preselectedType || 'group' };

  const createResource = (values) => {
    return createOrgStakeholder(values);
  };

  const validate = useCallback((values) => {
    const errors = {};

    if (values.objectType === 'group') {
      if (!values.name) {
        errors.name = 'Name is required';
      }
    } else {
      if (!values.firstName) {
        errors.firstName = 'First name is required';
      }

      if (!values.lastName) {
        errors.lastName = 'Last name is required';
      }
      if (!values.email) {
        errors.email = 'Email is required';
      }
    }
    return errors;
  }, []);

  return (
    <FormModal
      resource={initialValues}
      createResource={createResource}
      onHide={onHide}
      onSubmitSuccess={({ result }) => onSubmitSuccess(result)}
      resourceName="Organization Stakeholder"
      show={show}
      validate={validate}
    >
      <OrgStakeholderForm
        stakeholderTypeOptions={stakeholderTypeOptions}
        preselectedType={preselectedType}
      />
    </FormModal>
  );
}

export default connect(null, mapDispatchToProps)(OrgStakeholderFormModal);
